import Swiper from 'swiper/bundle';

export default class GoodsSlider {

    constructor(){
        this.swiper = null;
        this.$thumbs = [...document.querySelectorAll('.js-slide_thumb')];
        
        this._init();
    }

    _init() {
        const $slider = document.querySelector('.js-slide_ph');
        if(!$slider) return;

        this.swiper = new Swiper($slider, {
            slidesPerView: 1,
            speed: 500,
            on: {
                slideChange: (swiper) => {
                    this._updateThumbs(swiper.activeIndex);
                },
            },
        });

        this._eventBind();
    }

    _eventBind(){

        this.$thumbs.forEach(($thumb, index) => {
            $thumb.addEventListener('click', () => {
                this.swiper.slideTo(index);
            });
        });
    }

    _updateThumbs(activeIndex) {
        this.$thumbs.forEach(($thumb, index) => {
            $thumb.classList.toggle('is-active', index === activeIndex);
        });
    }
}